export const findFaultDtcDescriptor = (faultSeries = {}, datapointDescriptorsByKey = {}) => {
  //create array of the series fault key without fist portial (equipment:76767676)
  const [throwFirstPart, ...serieskeyArraywithoutEquipPart] = (faultSeries.key || '').split('.'); //eslint-disable-line no-unused-vars

  if (serieskeyArraywithoutEquipPart.length === 0) {
    return undefined;
  }

  let key = serieskeyArraywithoutEquipPart.sort().join('.');
  return datapointDescriptorsByKey[key];
};

export const formatFaultCode = (faultSeries = {}) => {
  let faultCode;
  //fault code is part of the series key and can be found in diff items in series attrs
  const seriesAttr = faultSeries.attrs || {};
  const dtc = 'DTC';
  switch (seriesAttr.type) {
    case 'j1939': {
      const spn = seriesAttr.spn ? `${seriesAttr.spn}` : '';
      const fmi = seriesAttr.fmi ? `${seriesAttr.fmi}` : '';
      const source = seriesAttr.source ? `${seriesAttr.source}` : '';
      faultCode = `${dtc}: j1939, SPN: ${spn}, FMI: ${fmi}, Source: ${source}`;
      break;
    }
    case 'obd2': {
      const code = faultSeries.attrs.code ? `${faultSeries.attrs.code}` : '';
      faultCode = `${dtc}: OBD2, Code: ${code}`;
      break;
    }
    case 'railway': {
      const code = faultSeries.attrs.code ? `${faultSeries.attrs.code}` : '';
      const source = faultSeries.attrs.source ? `${faultSeries.attrs.source}` : '';
      const severity = faultSeries.attrs.severity ? `${faultSeries.attrs.severity}` : '';
      faultCode = `${dtc}: Railway, Source: ${source.toUpperCase()}, Code: ${code}, Severity: ${severity}`;
      break;
    }
    case 'genie': {
      const code = faultSeries.attrs.code ? `${faultSeries.attrs.code}` : '';
      const source = faultSeries.attrs.source ? `${faultSeries.attrs.source}` : '';
      const category = faultSeries.attrs.category ? `${faultSeries.attrs.category}` : '';
      faultCode = `${dtc}: Genie, Code: ${code}, Category: ${category}, Source: ${source}`;
      break;
    }
  }

  return faultCode;
};

export const IsTSeriesDevice = (attrs = {}) => {
  const deviceModel = attrs['onei3:model'];
  // t-series model start with t followed by numders (t25,t15)
  const tSeriesRegex = new RegExp('^(T|t)[0-9]+$');
  return tSeriesRegex.test(deviceModel);
};
